import React from "react";
interface Props {
  id?: string;
  className: string;
  children: React.ReactNode;
  href: string;
}
const LinkButton = ({
  id,
  className,
  href,
  children
}: Props) => <a id={id} className={`${className}`} href={href} data-sentry-component="LinkButton" data-sentry-source-file="index.tsx">
    {children}
  </a>;
export default LinkButton;